(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bhl-installer-directory"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-installer-directory]').forEach((directory) => {
    const search = directory.querySelector('[data-installer-search]');
    const region = directory.querySelector('[data-installer-region]');
    const cards = [...directory.querySelectorAll('[data-installer-card]')];
    const count = directory.querySelector('[data-installer-count]');
    const empty = directory.querySelector('[data-installer-empty]');
    const grid = directory.querySelector('[data-installer-grid]');
    const mapPanel = directory.querySelector('[data-installer-map-panel]');
    const mapCanvas = directory.querySelector('[data-installer-map]');
    const mapStatus = directory.querySelector('[data-installer-map-status]');
    const regionChips = directory.querySelector('[data-installer-region-chips]');
    const mapsKey = directory.dataset.googleMapsKey;
    const mapId = directory.dataset.googleMapId;
    const profileLabel = directory.dataset.mapProfileLabel;
    const callLabel = directory.dataset.mapCallLabel;
    const websiteLabel = directory.dataset.mapWebsiteLabel;
    const servesLabel = directory.dataset.mapServesLabel;
    const brandLogoUrl = directory.dataset.mapBrandLogo;
    let map;
    let infoWindow;
    let activeMarker;
    let markers = [];
    const collator = new Intl.Collator(undefined, { sensitivity: 'base' });
    cards.sort((a, b) => Number(b.dataset.featured === 'true') - Number(a.dataset.featured === 'true') || collator.compare(a.dataset.name, b.dataset.name));
    cards.forEach((card) => grid.append(card));
    const regions = [...new Set(cards.map((card) => card.dataset.region).filter(Boolean))].sort(collator.compare);
    regions.forEach((value) => {
      region.add(new Option(value, value.toLowerCase()));
      if (!regionChips) return;
      const button = document.createElement('button');
      const installerCount = cards.filter((card) => card.dataset.region === value).length;
      button.type = 'button';
      button.dataset.installerRegionChip = '';
      button.dataset.regionValue = value.toLowerCase();
      button.setAttribute('aria-pressed', 'false');
      button.textContent = `${value} ${installerCount}`;
      regionChips.append(button);
    });
    const syncRegionChips = () => {
      directory.querySelectorAll('[data-installer-region-chip]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.regionValue === region.value));
      });
    };
    const visibleCards = () => cards.filter((card) => !card.hidden);
    const syncMap = () => {
      if (!map || !window.google?.maps) return;
      const bounds = new google.maps.LatLngBounds();
      let visibleMarkers = 0;
      markers.forEach(({ card, marker }) => {
        const visible = !card.hidden;
        marker.setMap(visible ? map : null);
        if (!visible && marker === activeMarker) {
          infoWindow?.close();
          marker.setIcon(markerIcons.default);
          activeMarker = undefined;
        }
        if (visible) {
          bounds.extend(marker.getPosition());
          visibleMarkers += 1;
        }
      });
      if (visibleMarkers) {
        map.fitBounds(bounds, 72);
        if (visibleMarkers === 1) google.maps.event.addListenerOnce(map, 'idle', () => map.setZoom(Math.min(map.getZoom(), 10)));
      }
    };
    const loadGoogleMaps = () => {
      if (window.google?.maps) return Promise.resolve();
      if (window.__bhlGoogleMapsPromise) return window.__bhlGoogleMapsPromise;
      window.__bhlGoogleMapsPromise = new Promise((resolve, reject) => {
        const callback = '__bhlGoogleMapsReady';
        window[callback] = () => {
          delete window[callback];
          resolve();
        };
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(mapsKey)}&loading=async&v=weekly&callback=${callback}`;
        script.async = true;
        script.onerror = () => reject(new Error('Google Maps failed to load.'));
        document.head.append(script);
      });
      return window.__bhlGoogleMapsPromise;
    };
    let markerIcons;
    const loadBrandLogo = () => new Promise((resolve) => {
      if (!brandLogoUrl) {
        resolve();
        return;
      }
      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.decoding = 'async';
      image.onload = () => resolve(image);
      image.onerror = () => resolve();
      image.src = brandLogoUrl;
    });
    const createMarkerIcon = (fill, width, height, brandLogo) => {
      const pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
      const canvas = document.createElement('canvas');
      canvas.width = width * pixelRatio;
      canvas.height = height * pixelRatio;
      const context = canvas.getContext('2d');
      context.scale(pixelRatio * width / 46, pixelRatio * height / 58);
      context.beginPath();
      context.moveTo(23, 2);
      context.bezierCurveTo(11.4, 2, 2, 11.4, 2, 23);
      context.bezierCurveTo(2, 38.7, 23, 56, 23, 56);
      context.bezierCurveTo(23, 56, 44, 38.7, 44, 23);
      context.bezierCurveTo(44, 11.4, 34.6, 2, 23, 2);
      context.closePath();
      context.fillStyle = fill;
      context.fill();
      context.lineWidth = 3;
      context.strokeStyle = '#111419';
      context.stroke();
      context.beginPath();
      context.arc(23, 23, 14, 0, Math.PI * 2);
      context.fillStyle = '#fff';
      context.fill();
      context.save();
      context.clip();
      if (brandLogo?.naturalWidth) {
        const logoScale = Math.min(25 / brandLogo.naturalWidth, 25 / brandLogo.naturalHeight);
        const logoWidth = brandLogo.naturalWidth * logoScale;
        const logoHeight = brandLogo.naturalHeight * logoScale;
        context.drawImage(brandLogo, 23 - logoWidth / 2, 23 - logoHeight / 2, logoWidth, logoHeight);
      } else {
        context.fillStyle = '#111419';
        context.font = '700 8px sans-serif';
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.fillText('BHL', 23, 23);
      }
      context.restore();
      return {
        url: canvas.toDataURL('image/png'),
        size: new google.maps.Size(width, height),
        scaledSize: new google.maps.Size(width, height),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(width / 2, height),
      };
    };
    const createInfoCard = (card) => {
      const content = document.createElement('div');
      const header = document.createElement('div');
      const text = document.createElement('div');
      const heading = document.createElement('strong');
      const location = document.createElement('p');
      const areas = document.createElement('p');
      const actions = document.createElement('div');
      content.className = 'bhl-map-card';
      header.className = 'bhl-map-card__header';
      location.className = 'bhl-map-card__location';
      areas.className = 'bhl-map-card__areas';
      actions.className = 'bhl-map-card__actions';
      heading.textContent = card.dataset.label;
      location.textContent = card.dataset.location;
      text.append(heading, location);
      if (card.dataset.logoUrl) {
        const logo = document.createElement('img');
        logo.className = 'bhl-map-card__logo';
        logo.src = card.dataset.logoUrl;
        logo.alt = '';
        header.append(logo, text);
      } else {
        header.classList.add('bhl-map-card__header--no-logo');
        header.append(text);
      }
      if (card.dataset.areas) {
        areas.textContent = `${servesLabel} ${card.dataset.areas}`;
        content.append(header, areas);
      } else {
        content.append(header);
      }
      const addAction = (label, href, external = false) => {
        const link = document.createElement('a');
        link.href = href;
        link.textContent = label;
        if (external) {
          link.target = '_blank';
          link.rel = 'nofollow noopener';
        }
        actions.append(link);
      };
      addAction(profileLabel, card.dataset.profileUrl);
      if (card.dataset.phone) addAction(callLabel, `tel:${card.dataset.phone.replace(/[^\d+]/g, '')}`);
      if (card.dataset.website) addAction(websiteLabel, card.dataset.website, true);
      content.append(actions);
      return content;
    };
    const initializeMap = async () => {
      if (map || !mapCanvas || !mapsKey) return;
      try {
        const [, brandLogo] = await Promise.all([loadGoogleMaps(), loadBrandLogo()]);
        const options = { center: { lat: 38.5, lng: -96.5 }, zoom: 4, mapTypeControl: false, streetViewControl: false, fullscreenControl: true };
        if (mapId) options.mapId = mapId;
        map = new google.maps.Map(mapCanvas, options);
        infoWindow = new google.maps.InfoWindow();
        markerIcons = {
          default: createMarkerIcon('#ff9900', 50, 63, brandLogo),
          hover: createMarkerIcon('#ffad2e', 56, 71, brandLogo),
          active: createMarkerIcon('#f47f00', 60, 76, brandLogo),
        };
        markers = cards.filter((card) => card.dataset.latitude && card.dataset.longitude).map((card) => {
          const marker = new google.maps.Marker({
            position: { lat: Number(card.dataset.latitude), lng: Number(card.dataset.longitude) },
            map,
            title: card.dataset.label,
            icon: markerIcons.default,
            cursor: 'pointer',
            optimized: false,
          });
          marker.addListener('mouseover', () => {
            if (marker !== activeMarker) marker.setIcon(markerIcons.hover);
          });
          marker.addListener('mouseout', () => {
            if (marker !== activeMarker) marker.setIcon(markerIcons.default);
          });
          marker.addListener('click', () => {
            if (activeMarker && activeMarker !== marker) activeMarker.setIcon(markerIcons.default);
            activeMarker = marker;
            marker.setIcon(markerIcons.active);
            if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
              marker.setAnimation(google.maps.Animation.BOUNCE);
              window.setTimeout(() => marker.setAnimation(null), 680);
            }
            infoWindow.setContent(createInfoCard(card));
            infoWindow.open({ map, anchor: marker });
          });
          return { card, marker };
        });
        infoWindow.addListener('closeclick', () => {
          if (activeMarker) activeMarker.setIcon(markerIcons.default);
          activeMarker = undefined;
        });
        if (mapStatus) mapStatus.remove();
        syncMap();
      } catch (error) {
        if (mapStatus) mapStatus.textContent = 'The installer map could not load. Please use the list view or try again later.';
      }
    };
    const renderView = () => {
      const hasResults = visibleCards().length > 0;
      grid.hidden = !hasResults;
      if (mapPanel) mapPanel.hidden = !hasResults;
      if (mapPanel && hasResults) initializeMap();
    };
    const update = () => {
      const query = search.value.trim().toLowerCase();
      const selectedRegion = region.value;
      let visible = 0;
      cards.forEach((card) => {
        const matches = (!query || card.dataset.search.includes(query)) && (!selectedRegion || card.dataset.region.toLowerCase() === selectedRegion);
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      count.textContent = visible;
      empty.hidden = visible !== 0;
      syncRegionChips();
      renderView();
      syncMap();
    };
    search.addEventListener('input', update);
    region.addEventListener('change', update);
    directory.querySelectorAll('[data-installer-region-chip]').forEach((button) => button.addEventListener('click', () => {
      region.value = button.dataset.regionValue;
      update();
    }));
    directory.querySelectorAll('[data-installer-clear]').forEach((button) => button.addEventListener('click', () => { search.value = ''; region.value = ''; update(); search.focus(); }));
    syncRegionChips();
    renderView();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bhl-page-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.bhlPageHeroVideoReady) return;
    window.bhlPageHeroVideoReady = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-bhl-page-video-trigger]');
      if (!trigger) return;

      const videoId = trigger.dataset.videoId;
      if (!videoId) return;

      const start = Number.parseInt(trigger.dataset.videoStart || '0', 10);
      const end = Number.parseInt(trigger.dataset.videoEnd || '0', 10);
      const params = new URLSearchParams({ autoplay: '1', rel: '0' });
      if (start > 0) params.set('start', String(start));
      if (end > start) params.set('end', String(end));

      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?${params.toString()}`;
      iframe.title = trigger.getAttribute('aria-label') || 'Bright Home Lights video';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      trigger.replaceWith(iframe);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bhl-rich-page-content"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const demos = document.querySelectorAll('[data-bhl-designer-demo] video');
    if (!demos.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const loadVideo = (video) => {
      const source = video.querySelector('source[data-src]');
      if (!source || source.src) return;

      source.src = source.dataset.src;
      source.removeAttribute('data-src');
      video.load();

      if (!reduceMotion) {
        video.play().catch(() => {});
      }
    };

    if (!('IntersectionObserver' in window)) {
      demos.forEach(loadVideo);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loadVideo(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '400px 0px' });

    demos.forEach((video) => observer.observe(video));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bhl-youtube-chapter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.bhlYoutubeChapterReady) return;
    window.bhlYoutubeChapterReady = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-bhl-youtube-chapter-trigger]');
      if (!trigger) return;

      const videoId = trigger.dataset.videoId;
      const start = Number.parseInt(trigger.dataset.start || '0', 10);
      const end = Number.parseInt(trigger.dataset.end || '0', 10);
      const params = new URLSearchParams({ autoplay: '1', rel: '0' });
      if (start > 0) params.set('start', String(start));
      if (end > start) params.set('end', String(end));

      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?${params.toString()}`;
      iframe.title = trigger.getAttribute('aria-label') || 'Bright Home Lights video chapter';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      trigger.replaceWith(iframe);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
